export function validatePasswordPolicy(password) {
    if (typeof password !== 'string') {
        throw new Error(`Expected password to be string, got ${typeof password}`);
    }

    if (password.length < 8) {
        return 'Password requirements not met: at least 8 characters';
    }

    return null;
}
